import { Icon, Section } from '@ui/library';
import type { Bio as BioData, Era } from '@lib/schemas/site';
import { cx } from '@lib/utils/classNames';

export interface BioProps {
  bio: BioData;
  eras: ReadonlyArray<Era>;
}

export function Bio({ bio, eras }: BioProps) {
  return (
    <Section id="about">
      <div className="bio__grid reveal">
        <h2 className="bio__headline">{bio.headline}</h2>
        <div className="bio__body">
          {bio.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>
      <div className="eras reveal">
        {eras.map((era, i) => (
          <div key={era.name} style={{ display: 'contents' }}>
            {i > 0 && <Icon name="arrow-right" size={18} color="var(--aw-mint)" />}
            <div className={cx('era', era.now && 'era--now')}>
              <b>{era.name}</b>
              <span>{era.span}</span>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}
